// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdp-detail-block {
  padding: 0px var(--spacing-regular) var(--spacing-regular) var(--spacing-regular);
}
.pdp-detail-block .divider {
  width: 100%;
  height: 1px;
  background-color: #eaeaea;
  margin: var(--spacing-regular) 0;
}
.pdp-detail-block .redemption-by-points .redemption-label {
  font-size: var(--font-big);
  font-weight: 600;
  margin-bottom: 5px;
  cursor: auto;
}
.pdp-detail-block .redemption-by-points .redemption-regular-value {
  font-size: var(--font-paragraph);
  font-weight: 400;
  margin-bottom: var(--spacing-small);
  cursor: auto;
  text-decoration-line: line-through;
  color: var(--color-neutral-dark-darker);
}
.pdp-detail-block .redemption-by-points .redemption-value {
  font-size: var(--font-giant);
  font-weight: 600;
  margin-bottom: var(--spacing-small);
  cursor: auto;
  color: var(--color-neutral-dark-darker);
}
.pdp-detail-block .redemption-by-points .redemption-value span {
  color: var(--color-neutral-dark-darker);
  font-size: var(--font-big);
  font-weight: 400;
  margin-left: var(--spacing-extra-small);
}
.pdp-detail-block .redemption-by-points .points-and-cash-option {
  display: flex;
  align-items: center;
  gap: var(--spacing-extra-small);
  cursor: pointer;
}
.pdp-detail-block .redemption-by-points .points-and-cash-option .option-label {
  font-size: var(--font-paragraph);
  font-weight: 500;
  color: var(--color-detached);
  transition: color 0.2s ease-in-out;
}
.pdp-detail-block .redemption-by-points .points-and-cash-option:hover .option-label {
  color: var(--color-highlight-darker);
}
.pdp-detail-block .product-vendor-info {
  margin-bottom: 20px;
}
.pdp-detail-block .product-vendor-info .vendor-info .vert-paragraph {
  font-size: var(--font-paragraph);
  font-weight: 500;
  color: var(--color-neutral-light) !important;
}
.pdp-detail-block .product-vendor-info .vendor-name {
  border-radius: 100px;
  border: solid 1px #DDDDDD;
  padding: 8px 16px 8px 16px;
}
.pdp-detail-block .product-vendor-info .vendor-name .Xicon {
  vertical-align: text-bottom;
  margin-right: 5px;
}
.pdp-detail-block .product-reviews {
  display: flex;
  gap: var(--spacing-extra-small);
  margin-top: var(--spacing-regular);
}
.pdp-detail-block .product-reviews .vert-paragraph {
  font-size: var(--font-paragraph);
  font-weight: 600;
}
.pdp-detail-block .product-reviews .ant-rate {
  display: flex;
}
.pdp-detail-block .color-select-option {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-extra-small);
}
.pdp-detail-block .color-select-option .option-input-label {
  font-size: var(--font-paragraph);
  font-weight: 500;
  cursor: auto;
}
.pdp-detail-block .color-select-option .vert-select .ant-select-selector .ant-select-selection-item {
  font-weight: 500;
}
.pdp-detail-block .color-select-option .vert-select .ant-select-selector .ant-select-selection-placeholder {
  font-family: var(--font-family);
  font-size: var(--font-paragraph);
  color: var(--color-neutral-dark-lighter);
}
.pdp-detail-block .color-select-option .vert-select .ant-select-arrow {
  font-size: var(--font-paragraph);
  color: var(--color-neutral-dark-lighter);
}
.pdp-detail-block .shipping-wrapper {
  display: flex;
  flex-direction: column;
}
.pdp-detail-block .shipping-wrapper .shipping-load {
  display: flex;
  margin-top: var(--spacing-small);
}
.pdp-detail-block .shipping-wrapper .shipping-load .vert-loading .anticon {
  font-size: var(--font-giant) !important;
}
.pdp-detail-block .shipping-wrapper .shipping-load .vert-loading .anticon svg {
  fill: var(--color-detached);
}
.pdp-detail-block .shipping-wrapper .shipping-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pdp-detail-block .shipping-wrapper .shipping-header .shipping-label {
  font-size: var(--font-paragraph);
  font-weight: 600;
  cursor: auto;
}
.pdp-detail-block .shipping-wrapper .shipping-header .change-address-link {
  font-size: var(--font-paragraph);
  font-weight: 500;
  color: var(--color-detached);
  text-decoration: underline;
  transition: color 0.2s ease-in-out;
}
.pdp-detail-block .shipping-wrapper .shipping-header .change-address-link:hover {
  color: var(--color-highlight-darker);
}
.pdp-detail-block .shipping-wrapper .shipping-input-wrapper {
  display: flex;
  align-items: center;
  gap: var(--spacing-small);
  margin-top: var(--spacing-small);
}
.pdp-detail-block .shipping-wrapper .shipping-input-wrapper .shipping-search-link a {
  font-size: var(--font-paragraph);
  font-weight: 500;
  color: var(--color-detached);
  text-decoration: underline;
  transition: color 0.2s ease-in-out;
}
.pdp-detail-block .shipping-wrapper .shipping-input-wrapper .shipping-search-link a:hover {
  color: var(--color-highlight-darker);
}
.pdp-detail-block .shipping-wrapper .shipping-info-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
  margin-top: var(--spacing-small);
}
.pdp-detail-block .shipping-wrapper .shipping-info-wrapper .delivery-unavailable {
  display: flex;
  align-items: center;
  gap: var(--spacing-extra-small);
}
.pdp-detail-block .shipping-wrapper .shipping-info-wrapper .delivery-unavailable .vert-icon svg {
  fill: var(--color-yellow);
  width: 22px;
  height: 22px;
}
.pdp-detail-block .shipping-wrapper .shipping-info-wrapper .delivery-unavailable .vert-paragraph {
  font-size: var(--font-paragraph);
  font-weight: 400;
  color: var(--color-yellow);
  cursor: auto;
}
.pdp-detail-block .shipping-wrapper .shipping-info-wrapper .address-info .vert-paragraph {
  font-size: var(--font-paragraph);
  font-weight: 400;
  cursor: auto;
}
.pdp-detail-block .shipping-wrapper .shipping-info-wrapper .shipping-info {
  display: flex;
  gap: var(--spacing-extra-big);
}
.pdp-detail-block .shipping-wrapper .shipping-info-wrapper .shipping-info .vert-paragraph {
  font-size: var(--font-paragraph);
  font-weight: 400;
  cursor: auto;
}
.pdp-detail-block .shipping-wrapper .shipping-info-wrapper .shipping-info .vert-paragraph.label {
  font-weight: 500;
}
.pdp-detail-block .shipping-wrapper .shipping-info-wrapper .shipping-info .vert-paragraph .free-delivery {
  color: var(--color-highlight);
  font-weight: 500;
}
.pdp-detail-block .buttons-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
}
@media screen and (max-width: 480px) {
  .pdp-detail-block {
    padding: 0;
  }
  .pdp-detail-block .redemption-by-points .redemption-label {
    font-size: var(--font-medium);
  }
}
.cart-summary-coupom {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: var(--spacing-extra-small);
}
.cart-summary-coupom .cart-summary-form {
  width: 100%;
}
.cart-summary-coupom .cart-summary-form .cart-summary-form-item {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.cart-summary-coupom .cart-summary-form .cart-summary-coupon-input {
  display: flex;
  width: 100%;
}
.cart-summary-coupom .cart-summary-form .cart-summary-coupon-input .vert-input-container {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  margin-right: -15px;
  width: 100% !important;
}
.cart-summary-coupom .cart-summary-form .cart-summary-coupon-input .vert-input-container .vert-input:not(.ant-input-affix-wrapper).ant-input:not(.ant-input-affix-wrapper-borderless) {
  border-right: 0 !important;
}
.cart-summary-coupom .cart-summary-form .cart-summary-coupon-input button {
  padding: 0px var(--spacing-small);
}
.cart-summary-coupom .cart-summary-form .cart-summary-coupon-input button.ant-btn-loading {
  opacity: 0.65;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cart-summary-coupom .cart-summary-form .cart-summary-coupon-input button.ant-btn-loading.ant-btn-icon {
  margin-right: var(--spacing-extra-small);
}
.cart-summary-coupom .label {
  font-weight: 400 !important;
}
.cart-summary-coupom .coupon-card {
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: var(--spacing-extra-small);
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-family: var(--font-family);
  background-color: var(--color-detached);
  color: var(--color-white);
  position: relative;
}
.cart-summary-coupom .coupon-card .coupon-content {
  display: flex;
  justify-content: space-between;
  padding: 0 4px;
  align-items: center;
}
.cart-summary-coupom .coupon-card .coupon-content span {
  display: flex;
  align-items: center;
  justify-content: center;
}
.cart-summary-coupom .coupon-card .coupon-icon {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.cart-summary-coupom .coupon-card .icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.cart-summary-coupom .coupon-card .coupon-divider {
  width: 1px;
  height: 20px;
  background-color: var(--color-border);
  margin: 0 var(--spacing-extra-small);
}
.cart-summary-coupom .coupon-card .icon img {
  width: 16px;
  height: 16px;
}
.cart-summary-coupom .coupon-card .text {
  width: 160px;
  /* Largura fixa para a div de texto */
  font-size: 12px;
}
.cart-summary-coupom .coupon-card .text h3 {
  margin: 2px 0;
  font-size: 14px;
  color: var(--color-white);
  text-transform: uppercase;
}
.cart-summary-coupom .coupon-card .close-icon {
  margin-left: var(--spacing-extra-small);
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  cursor: pointer;
}
.cart-summary-coupom .coupon-card::before {
  background-color: var(--color-white);
  bottom: 0;
  content: '';
  display: block;
  height: 12px;
  overflow: hidden;
  position: absolute;
  top: 30%;
  left: -1px;
  width: 6px;
  border: 1px solid var(--color-border);
  border-left: none;
  border-bottom-right-radius: 16px;
  border-top-right-radius: 16px;
}
.cart-summary-coupom .coupon-card::after {
  background-color: var(--color-white);
  bottom: 0;
  content: '';
  display: block;
  height: 12px;
  overflow: hidden;
  position: absolute;
  top: 30%;
  right: -1px;
  width: 6px;
  border: 1px solid var(--color-border);
  border-right: none;
  border-bottom-left-radius: 16px;
  border-top-left-radius: 16px;
}
.cart-summary-coupom .coupon-card-invalid {
  background-color: var(--color-error) !important;
  border: 0.5px solid var(--color-error) !important;
  color: var(--color-white) !important;
}
.cart-summary-coupom .coupon-card-invalid .coupon-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.cart-summary-coupom .coupon-card-invalid .icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cart-summary-coupom .invalid-coupon-message {
  font-size: 14px;
  font-weight: 300;
  color: var(--color-error);
  margin-left: var(--spacing-extra-small);
}
.cart-summary-coupom .cart-summary-coupon-alert {
  margin: var(--spacing-small) 0;
}
.cart-loading-spin {
  color: var(--color-detached) !important;
  font-size: 16px;
}
.cart-summary-total-free {
  color: var(--color-highlight) !important;
  font-weight: 500 !important;
}
@media screen and (max-width: 768px) {
  .cart-loading-wrapper {
    width: 100%;
  }
  .cart-summary-coupon-list {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
  .coupon-content {
    display: flex;
    justify-content: space-between;
    margin: 0 var(--spacing-extra-small);
    width: 100%;
    align-items: center;
  }
  .coupon-content span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
@media screen and (max-width: 576px) {
  .cart-loading-wrapper {
    width: 100%;
  }
  .cart-loading-wrapper .cart-summary-coupon-list {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .cart-loading-wrapper .cart-summary-coupon-list .coupon-card {
    width: 100%;
  }
  .cart-summary-coupom .coupon-card {
    padding: var(--spacing-extra-small) 0px;
  }
  .coupon-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .coupon-content span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Product/ProductDetailBlockStyles.less"],"names":[],"mappings":"AACA;EACE,iFAAA;AAAF;AADA;EAMI,WAAA;EACA,WAAA;EACA,yBAAA;EACA,gCAAA;AAFJ;AAPA;EAcM,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AAJN;AAbA;EAoBM,gCAAA;EACA,gBAAA;EACA,mCAAA;EACA,YAAA;EACA,kCAAA;EACA,uCAAA;AAJN;AArBA;EA6BM,4BAAA;EACA,gBAAA;EACA,mCAAA;EACA,YAAA;EACA,uCAAA;AALN;AA5BA;EAoCQ,uCAAA;EACA,0BAAA;EACA,gBAAA;EACA,uCAAA;AALR;AAlCA;EA4CM,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,eAAA;AAPN;AAxCA;EAkDQ,gCAAA;EACA,gBAAA;EACA,4BAAA;EACA,kCAAA;AAPR;AAUM;EAEI,oCAAA;AATV;AAjDA;EAiEI,mBAAA;AAbJ;AApDA;EAqEQ,gCAAA;EACA,gBAAA;EACA,4CAAA;AAdR;AAzDA;EA4EM,oBAAA;EACA,yBAAA;EACA,0BAAA;AAhBN;AA9DA;EAiFQ,2BAAA;EACA,iBAAA;AAhBR;AAlEA;EAwFI,aAAA;EACA,+BAAA;EACA,kCAAA;AAnBJ;AAvEA;EA6FM,gCAAA;EACA,gBAAA;AAnBN;AA3EA;EAkGM,aAAA;AApBN;AA9EA;EAuGI,aAAA;EACA,sBAAA;EACA,+BAAA;AAtBJ;AAnFA;EA4GM,gCAAA;EACA,gBAAA;EACA,YAAA;AAtBN;AAxFA;EAoHU,gBAAA;AAzBV;AA3FA;EAwHU,+BAAA;EACA,gCAAA;EACA,wCAAA;AA1BV;AAhGA;EA8HQ,gCAAA;EACA,wCAAA;AA3BR;AApGA;EAqII,aAAA;EACA,sBAAA;AA9BJ;AAxGA;EAyIM,aAAA;EACA,gCAAA;AA9BN;AA5GA;EA8IU,uCAAA;AA/BV;AA/GA;EAgJY,2BAAA;AA9BZ;AAlHA;EAuJM,aAAA;EACA,mBAAA;EACA,8BAAA;AAlCN;AAvHA;EA4JQ,gCAAA;EACA,gBAAA;EACA,YAAA;AAlCR;AA5HA;EAkKQ,gCAAA;EACA,gBAAA;EACA,4BAAA;EACA,0BAAA;EACA,kCAAA;AAnCR;AAqCQ;EACE,oCAAA;AAnCV;AAtIA;EA+KM,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;AAtCN;AA5IA;EAsLU,gCAAA;EACA,gBAAA;EACA,4BAAA;EACA,0BAAA;EACA,kCAAA;AAvCV;AAyCU;EACE,oCAAA;AAvCZ;AAtJA;EAoMM,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,gCAAA;AA3CN;AA5JA;EA0MQ,aAAA;EACA,mBAAA;EACA,+BAAA;AA3CR;AAjKA;EAgNY,yBAAA;EACA,WAAA;EACA,YAAA;AA5CZ;AAtKA;EAuNU,gCAAA;EACA,gBAAA;EACA,0BAAA;EACA,YAAA;AA9CV;AA5KA;EAgOU,gCAAA;EACA,gBAAA;EACA,YAAA;AAjDV;AAjLA;EAuOQ,aAAA;EACA,6BAAA;AAnDR;AArLA;EA2OU,gCAAA;EACA,gBAAA;EACA,YAAA;AAnDV;AAqDU;EACE,gBAAA;AAnDZ;AA7LA;EAoPY,6BAAA;EACA,gBAAA;AApDZ;AAjMA;EA6PI,aAAA;EACA,sBAAA;EACA,yBAAA;AAzDJ;AA8DA;EACE;IACE,UAAA;EA5DF;EA2DA;IAKM,6BAAA;EA7DN;AACF;AAkEA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,mCAAA;AAhEF;AA4DA;EAOI,WAAA;AAhEJ;AAyDA;EAUM,aAAA;EACA,sBAAA;EACA,WAAA;AAhEN;AAoDA;EAgBQ,aAAA;EACA,WAAA;AAjER;AAgDA;EAoBU,0BAAA;EACA,6BAAA;EACA,mBAAA;EACA,sBAAA;AAjEV;AA0CA;EAyBY,0BAAA;AAhEZ;AAuCA;EA8BU,iCAAA;AAlEV;AAoEU;EACE,aAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;AAnEZ;AAqEY;EACE,wCAAA;AAnEd;AA2BA;EAoDI,2BAAA;AA5EJ;AAwBA;EAwDI,qCAAA;EACA,kBAAA;EACA,mCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,+BAAA;EACA,uCAAA;EACA,yBAAA;EACA,kBAAA;AA7EJ;AAWA;EAuEM,aAAA;EACA,8BAAA;EACA,cAAA;EACA,mBAAA;AA/EN;AAKA;EA8EQ,aAAA;EACA,mBAAA;EACA,uBAAA;AAhFR;AAAA;EAuFM,aAAA;EACA,mBAAA;EACA,2BAAA;AApFN;AALA;EA8FM,aAAA;EACA,mBAAA;EACA,uBAAA;AAtFN;AAVA;EAqGM,UAAA;EACA,YAAA;EACA,qCAAA;EACA,oCAAA;AAxFN;AAhBA;EA4GM,WAAA;EACA,YAAA;AAzFN;AApBA;EAiHM,YAAA;EA1FJ,qCAAqC;EA2FjC,eAAA;AAzFN;AAzBA;EAsHM,aAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;AA1FN;AA/BA;EA6HM,uCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;AA3FN;AA8FI;EACE,oCAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EAEA,UAAA;EACA,qCAAA;EACA,iBAAA;EACA,gCAAA;EACA,6BAAA;AA7FN;AAgGI;EACE,oCAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,qCAAA;EACA,kBAAA;EACA,+BAAA;EACA,4BAAA;AA9FN;AAxEA;EA2KI,+CAAA;EACA,iDAAA;EACA,oCAAA;AAhGJ;AA7EA;EAiLM,aAAA;EACA,mBAAA;EACA,uBAAA;AAjGN;AAlFA;EAuLM,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAlGN;AAzFA;EAkMI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,uCAAA;AAtGJ;AA/FA;EAyMI,8BAAA;AAvGJ;AA4GA;EACE,uCAAA;EACA,eAAA;AA1GF;AA6GA;EACE,wCAAA;EACA,2BAAA;AA3GF;AA+GA;EACE;IACI,WAAA;EA7GJ;EAgHA;IACI,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,eAAA;EA9GJ;EAgHA;IACE,aAAA;IACA,8BAAA;IACA,oCAAA;IACA,WAAA;IACA,mBAAA;EA9GF;EAyGA;IASI,aAAA;IACA,mBAAA;IACA,uBAAA;EA/GJ;AACF;AAmHA;EACE;IACE,WAAA;EAjHF;EAgHA;IAGI,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,sBAAA;EAhHJ;EA0GA;IASM,WAAA;EAhHN;EAsHA;IACE,uCAAA;EApHF;EAuHA;IACE,aAAA;IACA,8BAAA;IACA,mBAAA;EArHF;EAkHA;IAMI,aAAA;IACA,mBAAA;IACA,uBAAA;EArHJ;AACF","sourcesContent":["// DESKTOP\n.pdp-detail-block {\n  padding: 0px var(--spacing-regular) var(--spacing-regular)\n    var(--spacing-regular);\n  // max-width: 385px;\n\n  .divider {\n    width: 100%;\n    height: 1px;\n    background-color: #eaeaea;\n    margin: var(--spacing-regular) 0;\n  }\n\n  .redemption-by-points {\n    .redemption-label {\n      font-size: var(--font-big);\n      font-weight: 600;\n      margin-bottom: 5px;\n      cursor: auto;\n    }\n    .redemption-regular-value {\n      font-size: var(--font-paragraph);\n      font-weight: 400;\n      margin-bottom: var(--spacing-small);\n      cursor: auto;\n      text-decoration-line: line-through;\n      color: var(--color-neutral-dark-darker);\n    }\n\n    .redemption-value {\n      font-size: var(--font-giant);\n      font-weight: 600;\n      margin-bottom: var(--spacing-small);\n      cursor: auto;\n      color: var(--color-neutral-dark-darker);\n\n      span {\n        color: var(--color-neutral-dark-darker);\n        font-size: var(--font-big);\n        font-weight: 400;\n        margin-left: var(--spacing-extra-small);\n      }\n    }\n\n    .points-and-cash-option {\n      display: flex;\n      align-items: center;\n      gap: var(--spacing-extra-small);\n      cursor: pointer;\n\n      .option-label {\n        font-size: var(--font-paragraph);\n        font-weight: 500;\n        color: var(--color-detached);\n        transition: color 0.2s ease-in-out;\n      }\n\n      &:hover {\n        .option-label {\n          color: var(--color-highlight-darker);\n        }\n      }\n    }\n  }\n\n  .product-vendor-info {\n    margin-bottom: 20px;\n\n    .vendor-info {\n      .vert-paragraph {\n        font-size: var(--font-paragraph);\n        font-weight: 500;\n        color: var(--color-neutral-light) !important;\n      }\n    }\n\n    .vendor-name {\n      border-radius: 100px;\n      border: solid 1px #DDDDDD;\n      padding: 8px 16px 8px 16px;\n\n      .Xicon {\n        vertical-align: text-bottom;\n        margin-right: 5px;\n      }\n    }\n  }\n\n  .product-reviews {\n    display: flex;\n    gap: var(--spacing-extra-small);\n    margin-top: var(--spacing-regular);\n\n    .vert-paragraph {\n      font-size: var(--font-paragraph);\n      font-weight: 600;\n    }\n\n    .ant-rate {\n      display: flex;\n    }\n  }\n\n  .color-select-option {\n    display: flex;\n    flex-direction: column;\n    gap: var(--spacing-extra-small);\n\n    .option-input-label {\n      font-size: var(--font-paragraph);\n      font-weight: 500;\n      cursor: auto;\n    }\n\n    .vert-select {\n      .ant-select-selector {\n        .ant-select-selection-item {\n          font-weight: 500;\n        }\n\n        .ant-select-selection-placeholder {\n          font-family: var(--font-family);\n          font-size: var(--font-paragraph);\n          color: var(--color-neutral-dark-lighter);\n        }\n      }\n      .ant-select-arrow {\n        font-size: var(--font-paragraph);\n        color: var(--color-neutral-dark-lighter);\n      }\n    }\n  }\n\n  .shipping-wrapper {\n    display: flex;\n    flex-direction: column;\n\n    .shipping-load {\n      display: flex;\n      margin-top: var(--spacing-small);\n\n      .vert-loading {\n        .anticon {\n          font-size: var(--font-giant) !important;\n          svg {\n            fill: var(--color-detached);\n          }\n        }\n      }\n    }\n\n    .shipping-header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      .shipping-label {\n        font-size: var(--font-paragraph);\n        font-weight: 600;\n        cursor: auto;\n      }\n\n      .change-address-link {\n        font-size: var(--font-paragraph);\n        font-weight: 500;\n        color: var(--color-detached);\n        text-decoration: underline;\n        transition: color 0.2s ease-in-out;\n\n        &:hover {\n          color: var(--color-highlight-darker);\n        }\n      }\n    }\n\n    .shipping-input-wrapper {\n      display: flex;\n      align-items: center;\n      gap: var(--spacing-small);\n      margin-top: var(--spacing-small);\n\n      .shipping-search-link {\n        a {\n          font-size: var(--font-paragraph);\n          font-weight: 500;\n          color: var(--color-detached);\n          text-decoration: underline;\n          transition: color 0.2s ease-in-out;\n\n          &:hover {\n            color: var(--color-highlight-darker);\n          }\n        }\n      }\n    }\n\n    .shipping-info-wrapper {\n      display: flex;\n      flex-direction: column;\n      gap: var(--spacing-small);\n      margin-top: var(--spacing-small);\n\n      .delivery-unavailable {\n        display: flex;\n        align-items: center;\n        gap: var(--spacing-extra-small);\n\n        .vert-icon {\n          svg {\n            fill: var(--color-yellow);\n            width: 22px;\n            height: 22px;\n          }\n        }\n\n        .vert-paragraph {\n          font-size: var(--font-paragraph);\n          font-weight: 400;\n          color: var(--color-yellow);\n          cursor: auto;\n        }\n      }\n\n      .address-info {\n        .vert-paragraph {\n          font-size: var(--font-paragraph);\n          font-weight: 400;\n          cursor: auto;\n        }\n      }\n\n      .shipping-info {\n        display: flex;\n        gap: var(--spacing-extra-big);\n\n        .vert-paragraph {\n          font-size: var(--font-paragraph);\n          font-weight: 400;\n          cursor: auto;\n\n          &.label {\n            font-weight: 500;\n          }\n\n          .free-delivery {\n            color: var(--color-highlight);\n            font-weight: 500;\n          }\n        }\n      }\n    }\n  }\n\n  .buttons-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: var(--spacing-small);\n  }\n}\n\n// MOBILE\n@media screen and (max-width: 480px) {\n  .pdp-detail-block {\n    padding: 0;\n\n    .redemption-by-points {\n      .redemption-label {\n        font-size: var(--font-medium);\n      }\n    }\n  }\n}\n\n.cart-summary-coupom {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: var(--spacing-extra-small);\n\n  .cart-summary-form {\n    width: 100%;\n\n    .cart-summary-form-item{\n      display: flex;\n      flex-direction: column;\n      width: 100%;\n    }\n\n    .cart-summary-coupon-input {\n        display: flex;\n        width: 100%;\n        \n        .vert-input-container {\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0;\n          margin-right: -15px;\n          width: 100% !important;\n          .vert-input:not(.ant-input-affix-wrapper).ant-input:not(.ant-input-affix-wrapper-borderless) {\n            border-right: 0 !important;\n          }\n        }\n\n        button {\n          padding: 0px var(--spacing-small);\n\n          &.ant-btn-loading {\n            opacity: 0.65;\n            \n            display: flex;\n            align-items: center;\n            justify-content: center;\n\n            &.ant-btn-icon{\n              margin-right: var(--spacing-extra-small);\n            }\n            \n            \n          }\n        }\n\n\n      \n      }\n  }\n  .label {\n    font-weight: 400 !important;\n  }\n\n  .coupon-card {\n    border: 1px solid var(--color-border);\n    border-radius: 8px;\n    padding: var(--spacing-extra-small);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    font-family: var(--font-family);\n    background-color: var(--color-detached);\n    color: var(--color-white);\n    position: relative;\n   \n\n\n    .coupon-content {\n      display: flex;\n      justify-content: space-between;\n      padding: 0 4px;\n      align-items: center;\n      \n\n      span{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      \n  \n      }\n    }\n\n    .coupon-icon {\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n    }\n\n    .icon {\n      \n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n    }\n\n    .coupon-divider {\n      width: 1px;\n      height: 20px;\n      background-color: var(--color-border);\n      margin: 0 var(--spacing-extra-small);\n    }\n\n    .icon img {\n      width: 16px;\n      height: 16px;\n    }\n\n    .text {\n      width: 160px; /* Largura fixa para a div de texto */\n      font-size: 12px;\n    }\n\n    .text h3 {\n      margin: 2px 0;\n      font-size: 14px;\n      color: var(--color-white);\n      text-transform: uppercase;\n    }\n\n    .close-icon {\n      margin-left: var(--spacing-extra-small);\n      font-weight: 600;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 12px;\n      cursor: pointer;\n    }\n\n    &::before {\n      background-color: var(--color-white);\n      bottom: 0;\n      content: '';\n      display: block;\n      height: 12px;\n      overflow: hidden;\n      position: absolute;\n      top: 30%;\n      left: -1px;\n\n      width: 6px;\n      border: 1px solid var(--color-border);\n      border-left: none;\n      border-bottom-right-radius: 16px;\n      border-top-right-radius: 16px;\n    }\n\n    &::after {\n      background-color: var(--color-white);\n      bottom: 0;\n      content: '';\n      display: block;\n      height: 12px;\n      overflow: hidden;\n      position: absolute;\n      top: 30%;\n      right: -1px;\n      width: 6px;\n      border: 1px solid var(--color-border);\n      border-right: none;\n      border-bottom-left-radius: 16px;\n      border-top-left-radius: 16px;\n    }\n  }\n\n  .coupon-card-invalid {\n    background-color: var(--color-error) !important;\n    border: 0.5px solid var(--color-error) !important;\n    color: var(--color-white) !important;\n\n\n    .coupon-icon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .icon {\n      width: 20px;\n      height: 20px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      \n      \n    }\n  }\n\n  .invalid-coupon-message {\n    font-size: 14px;\n    font-weight: 300;\n    color: var(--color-error);\n    margin-left: var(--spacing-extra-small);\n  }\n\n  .cart-summary-coupon-alert{\n    margin: var(--spacing-small) 0;\n  }\n\n}\n\n.cart-loading-spin {\n  color: var(--color-detached) !important;\n  font-size: 16px;\n}\n\n.cart-summary-total-free {\n  color: var(--color-highlight) !important;\n  font-weight: 500 !important;\n}\n\n\n@media screen and (max-width: 768px){\n  .cart-loading-wrapper {\n      width: 100%;\n  }\n\n  .cart-summary-coupon-list {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-wrap: wrap;\n  }\n  .coupon-content {\n    display: flex;\n    justify-content: space-between;\n    margin: 0 var(--spacing-extra-small);\n    width: 100%;\n    align-items: center;\n    \n\n    span{\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n}\n\n@media screen and (max-width: 576px){\n  .cart-loading-wrapper{\n    width: 100%;\n    .cart-summary-coupon-list{\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-direction: column;\n      \n      .coupon-card{\n        width: 100%;\n      }  \n    }\n\n  }\n\n  .cart-summary-coupom .coupon-card{\n    padding: var(--spacing-extra-small) 0px;\n  }\n\n  .coupon-content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    \n    span{\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n\n\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
